let titlePrefix: string | undefined = 'Everfi -';

export function setTitlePrefix(prefix: string | undefined): void {
  titlePrefix = prefix;
}

export function getTitlePrefix(): string | undefined {
  return titlePrefix;
}
